import React, { useRef, useEffect } from "react";
import style from "./BlogPost.module.css";
import BlogData from "../BlogData";
import { filterPost } from "../ArrayFilter";
import BlogPostContent from "./BlogPostContent/Content";
import CommentForm from "./CommentForm/CommentForm";
import NewsLetter from "../TopSection/NewsLetter/NewsLetter";
function BlogPost({ match }) {
  const progressBar = useRef(null);
  useEffect(() => {
    document.title = match.params.post.split("-").join(" ");
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    document.addEventListener("scroll", progressBarFunction);

    return function cleanUp() {
      document.removeEventListener("scroll", progressBarFunction);
    };
  }, [match.params.post]);

  function progressBarFunction() {
    let winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    let height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    let scrolled = (winScroll / height) * 100;
    progressBar.current.style.width = scrolled + "%";
  }

  const data = filterPost(BlogData, match.params.post);
  return (
    <div className={style.wrapper}>
      <div className={style.progressContainer}>
        <div className={style.progressBar} ref={progressBar}></div>
      </div>
      <BlogPostContent data={data[0]} />
      <CommentForm />
      <NewsLetter
        display="sideBySide"
        imgSrc="https://invozone.com/wp-content/uploads/2020/04/Blogsj.png"
      />
    </div>
  );
}

export default BlogPost;
